import { Box, Button, Card } from "@material-ui/core";
import * as React from "react";

export default function SegmentCompatibleNotificationModal({
  eventIds,
  onClose,
  eventsByID,
}) {
  if (!eventIds) {
    return null;
  }

  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Card style={{ padding: 32 }}>
        <p>
          Some of the selected events have hardcoded destinations. If you want
          to better understand why they can't have their destinations changed
          manually, please{" "}
          <a
            style={{ color: "#3F51B5", textDecoration: "underline" }}
            href="https://documentation.freshpaint.io/developer/http-api#configuring-which-destinations-server-side-events-are-sent-to"
            rel="noopener noreferrer"
            target="_blank"
          >
            read more info on our docs
          </a>
          .
        </p>
        <p style={{ margin: "12px 0" }}>
          <strong>Events with hardcoded destinations:</strong>
        </p>
        <ul>
          {eventIds.map((e) => (
            <li key={e}>{eventsByID[e].name}</li>
          ))}
        </ul>
        <Box
          width="100%"
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          mt="32px"
        >
          <Button
            style={{
              backgroundColor: "#3F51B5",
              color: "white",
            }}
            variant="contained"
            onClick={onClose}
          >
            OK
          </Button>
        </Box>
      </Card>
    </Box>
  );
}
